<div class="global-nav-container">
  <app-global-header [sidebarMetadata]="sidebarMetadata"></app-global-header>
  @if (globals.isBrowser) {
  <app-search-window></app-search-window>
  }
</div>
<router-outlet></router-outlet>
@if (showFooter) {
<app-footer [ngClass]="globalFooterOffset ? '-footer-offset' : ''"></app-footer>
}
